export { PartnershipsHeader } from './PartnershipsHeader'
